/* ==========================================================================
   KCONV Bundles – live totaal/besparing + toevoegen aan winkelwagen.
   Officiële Shopify-aanpak: POST /cart/add.js met een { items: [...] } body.
   Raakt geen kernbestand aan.
   ========================================================================== */
(function () {
  if (window.__kconvBundlesInit) return;
  window.__kconvBundlesInit = true;

  function activeCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  }

  // Formatteer bedragen in de ACTIEVE (presentment) valuta, net als de rest van
  // het thema. Bedragen staan al in de juiste valuta (subeenheden).
  function money(cents) {
    try {
      if (typeof webvista !== 'undefined' && webvista && typeof webvista.formatPriceAmount === 'function') {
        var out = webvista.formatPriceAmount(cents, activeCurrency());
        if (out) return out;
      }
    } catch (e) {}
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: activeCurrency() }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function isIncluded(item) {
    if (item.dataset.optional !== 'true') return true;
    var cb = item.querySelector('[data-kconv-bndl-toggle]');
    return cb ? cb.checked : true;
  }

  function currentVariant(item) {
    var sel = item.querySelector('[data-kconv-bndl-variant]');
    if (sel && sel.options[sel.selectedIndex]) {
      var o = sel.options[sel.selectedIndex];
      return {
        id: o.value,
        price: parseInt(o.dataset.price, 10) || 0,
        compare: parseInt(o.dataset.compare, 10) || 0,
        available: o.dataset.available === 'true',
        deliveryDays: parseInt(o.dataset.deliveryDays, 10) || 0,
        deliveryHtml: o.dataset.deliveryHtml || ''
      };
    }
    return {
      id: item.dataset.variantId,
      price: parseInt(item.dataset.price, 10) || 0,
      compare: parseInt(item.dataset.compare, 10) || 0,
      available: item.dataset.available === 'true',
      deliveryDays: parseInt(item.dataset.deliveryDays, 10) || 0,
      deliveryHtml: item.dataset.deliveryHtml || ''
    };
  }

  function recalc(bundle) {
    var items = bundle.querySelectorAll('[data-kconv-bndl-item]');
    var total = 0;
    var compareTotal = 0;
    var accCompare = 0;
    var accPrice = 0;
    var count = 0;
    var allInStock = true;
    var maxDelDays = 0;
    var worstDelHtml = '';

    items.forEach(function (item) {
      if (!isIncluded(item)) {
        item.classList.add('is-off');
        return;
      }
      item.classList.remove('is-off');
      var v = currentVariant(item);
      if (!v.available) allInStock = false;
      var base = v.compare && v.compare > v.price ? v.compare : v.price;
      total += v.price;
      compareTotal += base;
      count += 1;
      // Langste (laatste) levertijd van de actieve items onthouden.
      if (v.deliveryDays > maxDelDays) {
        maxDelDays = v.deliveryDays;
        worstDelHtml = v.deliveryHtml;
      }
      if (item.dataset.optional === 'true') {
        accPrice += v.price;
        accCompare += base;
      }
    });

    // Optionele extra bundelkorting (weergave) op de accessoires.
    var pct = parseInt(bundle.dataset.bundleDiscount, 10) || 0;
    var extra = 0;
    if (pct > 0) {
      extra = Math.round((accPrice * pct) / 100);
      total -= extra;
    }

    var savings = compareTotal - total;

    var totalEl = bundle.querySelector('[data-kconv-bndl-total]');
    var compareEl = bundle.querySelector('[data-kconv-bndl-compare]');
    var savingsEl = bundle.querySelector('[data-kconv-bndl-savings]');
    var savingsPctEl = bundle.querySelector('[data-kconv-bndl-savings-pct]');
    var stockEl = bundle.querySelector('[data-kconv-bndl-stock]');
    var addBtn = bundle.querySelector('[data-kconv-bndl-add]');

    if (totalEl) totalEl.textContent = money(total);
    if (compareEl) {
      if (savings > 0) {
        compareEl.textContent = money(compareTotal);
        compareEl.hidden = false;
      } else {
        compareEl.hidden = true;
      }
    }
    if (savingsEl) {
      if (savings > 0 && compareTotal > 0) {
        var savePct = Math.round((savings * 100) / compareTotal);
        if (savingsPctEl) {
          var discTpl = bundle.dataset.i18nDiscount || '__PCT__% korting';
          savingsPctEl.textContent = discTpl.replace('__PCT__', savePct);
        }
        savingsEl.hidden = false;
      } else {
        savingsEl.hidden = true;
      }
    }
    if (stockEl) {
      if (!allInStock) {
        // Een geselecteerde variant is uitverkocht.
        stockEl.classList.add('is-oos');
        stockEl.classList.remove('is-delayed');
        stockEl.innerHTML = bundle.__stockDefault || stockEl.innerHTML;
        var oosText = stockEl.querySelector('span');
        if (oosText) oosText.textContent = bundle.dataset.i18nNotAllStock || 'Niet alles op voorraad';
      } else if (maxDelDays > 0 && worstDelHtml) {
        // Niet direct op voorraad: toon de langste (laatste) levertijd.
        stockEl.classList.remove('is-oos');
        stockEl.classList.add('is-delayed');
        stockEl.innerHTML = worstDelHtml;
      } else {
        // Alles direct op voorraad.
        stockEl.classList.remove('is-oos', 'is-delayed');
        stockEl.innerHTML = bundle.__stockDefault || stockEl.innerHTML;
        var okText = stockEl.querySelector('span');
        if (okText) okText.textContent = bundle.dataset.i18nInStock || 'Op voorraad';
      }
    }
    if (addBtn) addBtn.disabled = count === 0 || !allInStock;
  }

  function updateItemPrice(item) {
    var v = currentVariant(item);
    item.dataset.variantId = v.id;
    var sel = item.querySelector('[data-kconv-bndl-variant]');
    var labelEl = item.querySelector('[data-kconv-bndl-variant-label]');
    if (labelEl && sel && sel.options[sel.selectedIndex]) {
      var txt = sel.options[sel.selectedIndex].text.split(' \u2014 ')[0].trim();
      if (txt && txt !== 'Default Title') {
        labelEl.textContent = txt;
        labelEl.hidden = false;
      } else {
        labelEl.hidden = true;
      }
    }
    var priceEl = item.querySelector('.kconv-bndl-item__current-price');
    var compareEl = item.querySelector('.kconv-bndl-item__compare');
    if (priceEl) {
      priceEl.textContent = money(v.price);
      priceEl.classList.toggle('is-sale', v.compare > v.price);
    }
    if (compareEl) {
      if (v.compare > v.price) {
        compareEl.textContent = money(v.compare);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    // Levertijd van de gekozen variant bijwerken.
    var delEl = item.querySelector('[data-kconv-bndl-delivery]');
    if (delEl) delEl.innerHTML = v.deliveryHtml || '';
    item.dataset.deliveryDays = v.deliveryDays || 0;
    item.dataset.deliveryHtml = v.deliveryHtml || '';
    item.classList.toggle('kconv-bndl-item--unavailable', !v.available);
  }

  function cartSectionsToRender() {
    var list = [
      { id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
      { id: 'Bottom-Cart-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && !drawer.hasAttribute('data-status-silence')) {
      list.push({ id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-count' });
      list.push({ id: 'Cart-Drawer', section: drawer.dataset.section || 'cart-drawer', selector: '#Cart-Drawer-Details' });
    }
    return list;
  }

  function fallbackBadges() {
    fetch((window.Shopify ? window.Shopify.routes.root : '/') + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        ['Cart-Icon-Bubble', 'Bottom-Cart-Bubble'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el && sections['cart-icon-bubble']) {
            var parsed = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (parsed) el.innerHTML = parsed.innerHTML;
          }
        });
      })
      .catch(function () {});
  }

  function addBundle(bundle, addBtn) {
    var items = bundle.querySelectorAll('[data-kconv-bndl-item]');
    var payload = [];
    items.forEach(function (item) {
      if (!isIncluded(item)) return;
      var v = currentVariant(item);
      if (!v.id) return;
      payload.push({ id: Number(v.id), quantity: 1 });
    });
    if (!payload.length) return;

    addBtn.classList.add('is-loading');
    addBtn.disabled = true;

    var sections = cartSectionsToRender();
    var sectionsParam = sections
      .map(function (s) { return s.section; })
      .filter(function (v, i, a) { return a.indexOf(v) === i; })
      .join(',');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload, sections: sectionsParam, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function (res) {
        var code = bundle.dataset.discountCode;
        if (code) {
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
          return;
        }

        // Header/cart bubble + cart drawer bijwerken (officiële thema-manier).
        if (res && res.sections && typeof SectionDynamicUpdate !== 'undefined') {
          try { SectionDynamicUpdate.updateSections(sections, res.sections); } catch (e) { fallbackBadges(); }
        } else if (window.CartUtils && typeof window.CartUtils.updateCartBadges === 'function') {
          window.CartUtils.updateCartBadges();
        } else {
          fallbackBadges();
        }

        // Cart-update event publiceren zodat andere componenten meeluisteren.
        try {
          if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
            webvista.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kconv-bundles' });
          }
        } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:updated'));
        window.dispatchEvent(new CustomEvent('cart:updated'));

        // Melding "toegevoegd": cart-drawer openen indien aanwezig, anders het
        // standaard header-cart-vinkje tonen (zelfde als de gewone add-to-cart).
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && !drawer.hasAttribute('data-status-silence') && typeof drawer.show === 'function') {
          drawer.show(addBtn);
        } else if (typeof window.showHeaderCartCheckmark === 'function') {
          window.showHeaderCartCheckmark();
        }

        // Knop-animatie (loading -> succes-vinkje).
        addBtn.classList.remove('is-loading');
        addBtn.classList.add('is-success');
        setTimeout(function () { addBtn.classList.remove('is-success'); addBtn.disabled = false; }, 1600);
      })
      .catch(function (err) {
        addBtn.classList.remove('is-loading', 'is-success');
        addBtn.disabled = false;
        if (err && typeof err.json === 'function') {
          err.json().then(function (d) { alert(d.description || 'Er is een fout opgetreden.'); }).catch(function () { alert('Er is een fout opgetreden.'); });
        } else {
          alert('Er is een fout opgetreden.');
        }
      });
  }

  function initBundle(bundle) {
    if (bundle.__kconvBundle) return;
    bundle.__kconvBundle = true;

    // Standaard "Op voorraad"-markup bewaren om naar terug te schakelen.
    var stockEl0 = bundle.querySelector('[data-kconv-bndl-stock]');
    if (stockEl0) bundle.__stockDefault = stockEl0.innerHTML;

    bundle.querySelectorAll('[data-kconv-bndl-toggle]').forEach(function (cb) {
      cb.addEventListener('change', function () { recalc(bundle); });
    });

    bundle.querySelectorAll('[data-kconv-bndl-variant]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var item = sel.closest('[data-kconv-bndl-item]');
        if (item) updateItemPrice(item);
        recalc(bundle);
        // Sluit het "Andere opties"-uitklapmenu na keuze.
        var det = sel.closest('details');
        if (det) det.open = false;
      });
    });

    var addBtn = bundle.querySelector('[data-kconv-bndl-add]');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
        addBundle(bundle, addBtn);
      });
    }

    recalc(bundle);
  }

  function initAll() {
    document.querySelectorAll('[data-kconv-bundle]').forEach(initBundle);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
